import { useState } from 'react';
import { Alert, AlertTitle, AlertDescription, Button } from '@chakra-ui/react';
import { VisaStatusDescription, statusColorScheme } from './helpers';
import { VisaStatusModal } from './modal';
import { IVisaStatus } from '../../../../../types';

export interface IProps {
  saveVisaStatus: (data: { status: IVisaStatus }) => void;
  visaStatus: IVisaStatus;
}

export const VisaStatus = (props: IProps) => {
  const { visaStatus, saveVisaStatus } = props;

  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <Alert
      as="div"
      role="generic"
      data-selector="enrolment-section-visa-status-block"
      variant="status-block"
      colorScheme={statusColorScheme({ visaStatus })}
    >
      <AlertTitle as="h3">Visa Status</AlertTitle>

      <AlertDescription>
        <VisaStatusDescription visaStatus={visaStatus} />
      </AlertDescription>

      <Button
        size="lg"
        variant="solid"
        data-selector="enrolment-section-visa-status-button"
        onClick={() => setIsModalOpen(true)}
        mt={4}
      >
        Update visa status
      </Button>

      {isModalOpen && (
        <VisaStatusModal
          saveVisaStatus={saveVisaStatus}
          visaStatus={visaStatus}
          onModalClose={() => setIsModalOpen(false)}
        />
      )}
    </Alert>
  );
};
